(function($){
    
    $('.v2-tabs ul li').first().addClass('v2-active');
    $('.v2-tabs-content').first().show();

    $(document).on('click', '.v2-tabs li', function() {
      var id = $(this).data('id');
      $('.v2-tabs-content').hide();
      $('.v2-tabs ul li').removeClass('v2-active');
      $(this).addClass('v2-active');
      console.log( id );
      $('#'+id).show();
    });

     
    $(document).on('click', '.help_txt', function(){
      $(this).hide();
      $('.minorder_txt').slideDown();
    });

    $('li.sidebar-active').children('ul').show();   
    $('li.child-active').parent('ul').show();   
  
  	$(document).find('.site-navigation a').each(function() {
        var hotdeals = "hotdealsofthemonth";
        var elemText = $(this).text().toLowerCase().replace(/\s/g, '');
        if( hotdeals == elemText ) {
            $(this).addClass("hotdeals");
        }
    });
  
  $(document).on('click', '.search-collpase', function(){
        $('.live-search').slideToggle();
  });
  
  
  
  })(jQuery);

$('.category-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.offer-slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.product-slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.product-slider').on('setPosition', function () {
$(this).find('.slide-item').height('auto');
var slickTrack = $(this).find('.slick-track');
var slickTrackHeight = $(slickTrack).height();
$(this).find('.slide-item').css('height', slickTrackHeight + 'px');
});
$(document).ready(function(){  
  $('.show-more').on('click', function(e){
    e.preventDefault();
    var btn = $(this).toggleClass('active');
    if(btn.hasClass('active')) {
      btn.parent().find('.show-more-content').show();
      btn[0].innerHTML = 'Read Less'
    }
    else{
      btn.parent().find('.show-more-content').hide();
      btn[0].innerHTML = 'Read More'
    }
  })
});

(function($){
    'use strict';

    var findPrinter = {
        baseUrl: "https://services.mybcapps.com/bc-sf-filter/search?shop=3id-cards.myshopify.com&build_filter_tree=true",
    };

    // Load Printer Options
    $(window).on('load', function() {
        populateDefaultOptions();
    });

    $(document).find('.printer-selector').on('change', function() {
        
        var args = {
            step : $(this).data('step'),
            form : $(this).closest('form'),
            elem : $(this),
        }

        $(document).trigger('change_printer_selector', args );

    });

    $(document).on('click', '.printer-selector-form button', function( e ) {

        e.preventDefault();
        
        var action = $(this).data('action');

        if( action == 'reset' ) {
            populateDefaultOptions();
            return; 
        }

        if( action == 'submit' ) {
            
            var form = $(this).closest('form');
            var actionUrl = form.attr('action');
            var variables = {};

            form.find('select').each(function() {
                var value = $(this).val();
                var selectName = $(this).attr('name');
                if( value ) {
                    variables[ selectName ] = value; 
                }
            });

            if( Object.keys( variables ).length === 0 ) {
                alert('Please select an option.');
            } else {
                var args = $.param( variables );
                window.location.href = actionUrl + '?' + args;
            }
            
        }

    });

    $(document).on('click', '.id-printer-page-selector', function( e ) {
        var selectedPage = $(this).data('id');
        $('#id-printer-selector-landing').hide();
        $(selectedPage).show();
    });

    $(document).on('click', '.backtofirst', function( e){
        $('.id-printer-page-2').hide();
        $('#id-printer-selector-landing').show();
    });

    $(document).on('change_printer_selector', function( e, args ) {
        
        var form = args.form;
        var step = args.step;
        var elem = args.elem;

        // Disable Form until Ajax completes. 
        form.find('select').attr('disabled', 'disabled' );

        // If Step = 0 
        if( step == 0 ) {
            var tags = "&tag=" + elem.find(":selected").val();
        } else {
            var tags = "";
            form.find('select').not('elem').each(function( ){
                var selected = $(this).find(":selected").val();
                if( selected != "" && selected != 'undefined' ) {
                    tags += "&tag=" + $(this).find(":selected").val();
                }
            });
        }

        populateAjaxOptions( form, step, elem, tags );

    });

    function populateDefaultOptions() {
        $.get( findPrinter.baseUrl, function( data ) {
            var options  = data.filter.options;
            $.each( options, function( i, v ) {
                var elem = $( "#" + v.filterOptionId );
                if( elem.length > 0 ) {
                    elem.html( getOptions( v ) );
                }
            } );
        } );
    }

    function populateAjaxOptions( form, step, elem, tags ) {
        
        $.get(findPrinter.baseUrl + tags, function( data ){
            var options  = data.filter.options;
            
            $.each(options, function( i, v ){
                var otherElem = form.find( "#" + v.filterOptionId );
                var selected = (step == 0 ) ? elem.find(':selected').val() : otherElem.find(':selected').val();
                if( otherElem.length > 0 ) {
                    otherElem.html( getOptions( v, selected, otherElem.data('step') ) );
                }
            });

            form.find('select').attr('disabled', false );

        });
    }

    // Populate Options in the Form 
    function getOptions( data, selected = false, step ) {        
        
        var options = "<option value=''>Select "+data.label+"</option>";

        if( step == 0 ) {
            $.each( data.manualValues, function( i, v ) {
                if( selected == v ) {
                    options += "<option value='"+v+"' selected>"+v+"</option>";
                } else {
                    options += "<option value='"+v+"'>"+v+"</option>";
                }            
            });
        } else {
            $.each( data.values, function( i, v ) {
                if( selected == v.key ) {
                    options += "<option value='"+v.key+"' selected>"+v.key+"</option>";
                } else {
                    options += "<option value='"+v.key+"'>"+v.key+"</option>";
                }            
            });
        }
        
        return options; 
    }

})(jQuery);
